import { get, post } from "@/utils/request";
import type { Recall, CommonForm, Detail } from "@/types/procss";
import type { Response } from "@/types/axios";

//详情
export const detail = (params: { Id: number | string }) =>
  post("/api/companyGrand/detail", params);

//添加正式开业
export const add = (params: Detail) => post("/api/companyGrand/add", params);

//更新
export const edit = (params: Detail) => {
  return post("/api/companyGrand/edit", params);
};
//撤回
export const draw = (params: Recall) => {
  return post("/api/companyGrand/draw", params);
};
//审批
export const approve = (params: { Id: 0; Statuss: 0 }) => {
  return post("/api/companyGrand/approve", params);
};

// 获取公司帐号详情
export const companyAccountDetail = (params: {
  Id: number | string;
}): Promise<Response<Detail>> =>
  get("/api/companyAccount/companyAccountDetail", params);

//提交
export const submitCompanyAccountApply = (params: Detail) =>
  post("/api/companyAccount/submitCompanyAccountApply", params);

//更新
export const editCompanyAccountApply = (params: Detail) => {
  return post("/api/companyAccount/editCompanyAccountApply", params);
};
//撤回
export const recallCompanyAccountApply = (params: Recall) => {
  return post("/api/companyAccount/recallCompanyAccountApply", params);
};
